<template>
  <v-container class="px-5">
    <v-row>
      <v-col cols="12"
             lg="9">
        <h5>
          {{ $t('debtor.header') }}
        </h5>
        <p class="mb-0">
          {{ $t('debtor.desc-1') }}
        </p>
        <p>
          {{ $t('debtor.desc-2') }}
        </p>
      </v-col>
      <v-col cols="12"
             lg="9">
        <v-row v-for="(debtor, i) in debtors"
               :id="'debtor-' + (i * 1 + 1)"
               :key="i"
               :class="{ 'part-debtor-wrap': !debtor.mainDebtor }">
          <v-col cols="12">
            <h5 v-if="debtor.mainDebtor"
                class="mt-0">
              {{ $t('debtor.debtor') }}
            </h5>
            <h5 v-if="!debtor.mainDebtor && debtors.length > 1"
                class="mt-0">
              {{ $t('debtor.partDebtor') }}
              <v-btn text
                     icon
                     fab
                     class="error--text"
                     style="vertical-align: baseline;"
                     @click="$root.removeDebtor(i)">
                <v-icon>fa-trash-alt</v-icon>
              </v-btn>
            </h5>
          </v-col>
          <v-col cols="12">
            <div class="radio-tile-group">
              <div class="input-container">
                <input id="company"
                       v-model="debtor.isCompany"
                       class="radio-button"
                       type="radio"
                       :value="true"
                       @input="$root.$v.order.debtors.$each[i].isCompany.$touch()"
                       @change="$root.updateDebtor('isCompany', debtor.isCompany, i)">
                <div class="radio-tile">
                  <v-icon>fa-building</v-icon>
                  <label for="company"
                         class="radio-tile-label">{{ $t('common.company') }}</label>
                </div>
              </div>
              <div class="input-container">
                <input id="person"
                       v-model="debtor.isCompany"
                       class="radio-button"
                       type="radio"
                       :value="false"
                       @input="$root.$v.order.debtors.$each[i].isCompany.$touch()"
                       @change="$root.updateDebtor('isCompany', debtor.isCompany, i)">
                <div class="radio-tile">
                  <v-icon>fa-user</v-icon>
                  <label for="person"
                         class="radio-tile-label">{{ $t('common.person') }}</label>
                </div>
              </div>
            </div>
          </v-col>
          <v-col v-if="debtor.isCompany"
                 cols="12"
                 sm="6">
            <custom-input-group :model="debtor.companyBusinessId"
                                :validator="$root.$v.order.debtors.$each[i].companyBusinessId"
                                :maxlength="9"
                                label="businessId"
                                @update:model="$root.updateDebtor('companyBusinessId', $event, i); getBusinessIdDataFromYTJ(i)" />
          </v-col>
          <v-col v-if="debtor.isCompany"
                 cols="12"
                 sm="6">
            <custom-input-group :model="debtor.companyName"
                                :validator="$root.$v.order.debtors.$each[i].companyName"
                                :maxlength="41"
                                label="companyName"
                                @update:model="$root.updateDebtor('companyName', $event, i)" />
          </v-col>
          <v-col v-if="!debtor.isCompany"
                 cols="12"
                 sm="6">
            <custom-input-group :model="debtor.firstName"
                                :validator="$root.$v.order.debtors.$each[i].firstName"
                                :maxlength="41"
                                label="firstName"
                                @update:model="$root.updateDebtor('firstName', $event, i)" />
          </v-col>
          <v-col v-if="!debtor.isCompany"
                 cols="12"
                 sm="6">
            <custom-input-group :model="debtor.lastName"
                                :validator="$root.$v.order.debtors.$each[i].lastName"
                                :maxlength="41"
                                label="lastName"
                                @update:model="$root.updateDebtor('lastName', $event, i)" />
          </v-col>
          <v-col v-if="!debtor.isCompany"
                 cols="12"
                 sm="6">
            <custom-input-group :model="debtor.socSecNr"
                                :validator="$root.$v.order.debtors.$each[i].socSecNr"
                                :maxlength="11"
                                label="socSecNr"
                                @update:model="$root.updateDebtor('socSecNr', $event, i)" />
          </v-col>
          <v-col v-if="!debtor.isCompany"
                 cols="12"
                 sm="6">
            <div class="input-group">
              <label class="input-label">{{ $t('labels.language') }} *</label>
              <form-group name="language"
                          :validator="$root.$v.order.debtors.$each[i].language">
                <template slot-scope="{ attrs }">
                  <v-select v-model="debtor.language"
                            :items="languages"
                            item-text="text"
                            item-value="value"
                            v-bind="attrs"
                            @change="$root.updateDebtor('language', debtor.language, i)"
                            @input="$root.$v.order.debtors.$each[i].language.$touch()" />
                </template>
              </form-group>
            </div>
          </v-col>
          <v-col cols="12">
            <custom-input-group :model="debtor.streetAddress"
                                :validator="$root.$v.order.debtors.$each[i].streetAddress"
                                :maxlength="40"
                                label="streetAddress"
                                @update:model="$root.updateDebtor('streetAddress', $event, i)" />
          </v-col>
          <v-col cols="12"
                 sm="6">
            <custom-input-group :model="debtor.postalNumber"
                                :validator="$root.$v.order.debtors.$each[i].postalNumber"
                                :maxlength="5"
                                label="postalNumber"
                                @update:model="$root.updateDebtor('postalNumber', $event, i)" />
          </v-col>
          <v-col cols="12"
                 sm="6">
            <custom-input-group :model="debtor.city"
                                :validator="$root.$v.order.debtors.$each[i].city"
                                :maxlength="50"
                                label="city"
                                @update:model="$root.updateDebtor('city', $event, i)" />
          </v-col>
          <v-col cols="12"
                 sm="6">
            <custom-input-group :model="debtor.phone"
                                :validator="$root.$v.order.debtors.$each[i].phone"
                                :maxlength="14"
                                label="phone"
                                @update:model="$root.updateDebtor('phone', $event, i)" />
          </v-col>
          <v-col cols="12"
                 sm="6">
            <custom-input-group :model="debtor.email"
                                :validator="$root.$v.order.debtors.$each[i].email"
                                :maxlength="51"
                                label="email"
                                @update:model="$root.updateDebtor('email', $event, i)" />
          </v-col>
          <v-col cols="12"
                 sm="6">
            <div class="input-group">
              <label class="input-label">{{ $t('labels.country') }} *</label>
              <form-group name="country"
                          :validator="$root.$v.order.debtors.$each[i].country">
                <template slot-scope="{ attrs }">
                  <v-autocomplete v-model="debtor.country"
                                  v-bind="attrs"
                                  :items="countries"
                                  disabled
                                  item-text="text"
                                  item-value="value"
                                  @input="$root.$v.order.debtors.$each[i].country.$touch()"
                                  @change="$root.updateDebtor('country', debtor.country, i)" />
                </template>
              </form-group>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12"
                 class="text-center">
            <v-btn text
                   large
                   class="primary--text"
                   @click="$root.addNewDebtor">
              <v-icon class="mr-3">
                fa-plus
              </v-icon>
              <span>{{ $t('debtor.addPartDebtor') }}</span>
            </v-btn>
            <v-tooltip bottom max-width="300px">
              <template v-slot:activator="{ on }">
                <v-icon color="primary" dark v-on="on">fas fa-info-circle</v-icon>
              </template>
              <span>{{ $t('debtor.addPartDebtorTooltip') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="text-center"
                 cols="12">
            <v-btn large
                   tile
                   :disabled="!dirtyDebtors || debtorError"
                   :class="{ primary: dirtyDebtors && !debtorError }"
                   to="/order/bill">
              {{ $t('common.continue') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="importFromYTJDialog"
              :fullscreen="$root.dialogSettings.fullscreen"
              :scrollable="$root.dialogSettings.scrollable"
              :hide-overlay="$root.dialogSettings.hideoverlay"
              :transition="$root.dialogSettings.transition"
              :width="$root.dialogSettings.width"
              :max-width="$root.dialogSettings.maxwidth"
              persistent>
      <v-card>
        <v-card-title primary-title
                      class="text-h5 primary white--text">
          {{ $t('ytj.header') }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12"
                     sm="6">
                <p>{{ $t('ytj.text-1') }} <b>{{ prhData.businessId }}</b> {{ $t('ytj.text-2') }} <b>{{ prhData.companyName }}</b></p>
                <p>{{ $t('ytj.question') }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary"
                 text
                 @click="importFromYTJDialog = false">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn color="primary"
                 text
                 @click="savePrhData">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    data: () => ({
      importFromYTJDialog: false,
      prhData: {
        index: 0,
        businessId: '',
        companyName: '',
        address: {
          street: '',
          postCode: '',
          city: '',
          country: ''
        }
      }
    }),
    computed: {
      debtors () {
        return this.$store.getters.debtors
      },
      languages () {
        return [
          { text: this.$t('languages.1'), value: 1 },
          { text: this.$t('languages.2'), value: 2 },
          { text: this.$t('languages.3'), value: 3 },
          { text: this.$t('languages.4'), value: 4 },
          { text: this.$t('languages.6'), value: 6 },
          { text: this.$t('languages.7'), value: 7 },
          { text: this.$t('languages.5'), value: 5 }
        ]
      },
      countries () {
        return this.$store.getters.countries
      },
      dirtyDebtors () {
        return this.$store.getters.dirtyDebtors
      },
      debtorError () {
        return this.$store.getters.debtorError
      }
    },
    watch: {
      $route () {
        this.$root.scrollTo(this.$router.currentRoute.hash)
      }
    },
    created () {
      this.$root.scrollTo(this.$router.currentRoute.hash)
    },
    methods: {
      savePrhData () {
        if (this.prhData.address.companyName !== '') { this.$root.updateDebtor('companyName', this.prhData.companyName, this.prhData.index) }
        if (this.prhData.address.street !== '') { this.$root.updateDebtor('streetAddress', this.prhData.address.street, this.prhData.index) }
        if (this.prhData.address.postCode !== '') { this.$root.updateDebtor('postalNumber', this.prhData.address.postCode, this.prhData.index) }
        if (this.prhData.address.city !== '') { this.$root.updateDebtor('city', this.prhData.address.city, this.prhData.index) }
        // if (this.prhData.address.country !== '') { this.$root.updateDebtor('country', this.prhData.address.country, this.prhData.index) }
        this.$root.$v.order.debtors.$touch()
        this.importFromYTJDialog = false
      },
      getBusinessIdDataFromYTJ (index) {
        this.prhData.index = index
        var value = this.debtors[index].companyBusinessId
        if (value.length === 8) { value = value.substr(0, 7) + '-' + value.substr(7, 8) }

        if (value.length === 9 && value.indexOf('-') > 0) {
          axios.get('https://avoindata.prh.fi/bis/v1/' + value).then((response) => {
            if (response.data && response.data.results != null && response.data.results.length > 0) {
              var result = response.data.results[0]

              this.prhData.businessId = value
              this.prhData.companyName = result.name
              this.prhData.address.street = ''
              this.prhData.address.postCode = ''
              this.prhData.address.city = ''
              this.prhData.address.country = 'FI'

              if (result.addresses.length > 0) {
                var address = result.addresses[result.addresses.length - 1]

                this.prhData.address.street = address.street
                this.prhData.address.postCode = address.postCode
                this.prhData.address.city = address.city
              }

              this.importFromYTJDialog = true
            }
          })
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.$root.$v.order.debtors.$anyDirty) {
        this.$root.$v.order.debtors.$touch()
      }
      next()
    }
  }
</script>

<style>
    .part-debtor-wrap {
        border: 2px solid #d3d3d3;
        padding: 1rem;
        margin: 0 !important;
    }
</style>
